export default {
  appName: '静源健康',
  userInfoHidden: false,
  documentIco: '',
  logoExpand: require('@/assets/logo-big.png'),
  logoContract: require('@/assets/logo.png'),
  logout: ''
}
